import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { CFRD_GALLERY } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/cfrd/gallery/new")({
  component: () => <DeptContentForm cfg={CFRD_GALLERY} />,
});
